import moment from 'moment';
import { DateRange, OperationType } from '../../../../ResourceMapper/types';

export type State = {
  operationTypes: OperationType[];
  dateRange: DateRange;
};

export const initialState: State = {
  dateRange: { start: moment().subtract(1, 'year'), end: moment() },
  operationTypes: [OperationType.ALL],
};

export type Actions = {
  setDateRange: (dateRange: any) => void;
  setOperationsType: (values: any) => void;
};

export type FiltersStore = State & Actions;
